import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { EditIcon, EyeSvg } from "assets/images/common/svgs";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

import editProfileUSer from "assets/images/common/others/editProfileUSer.png";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useProductItem from "containers/master-portal/useHooks";
import useStore from "hooks/useStore";
import { sitePermissions } from "utils/helpers/enums/permissions.enum";
import Pagination from "components/particles/table/pagination";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";

interface ProductFilters {
  page: number;
  limit: number;
}

const ProductItems: React.FC = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<ProductFilters>({
    page: 1,
    limit: 9,
  });
  const [totalElements, setTotalElements] = useState<number>(0);
  const { getProductItems, updateProductItemStatus } = useProductItem();

  const fetchProductItems = (filterParams?: ProductFilters) => {
    const activeFilters = filterParams || filters;
    const queryParams = {
      page: activeFilters.page - 1,
      size: activeFilters.limit,
    };
    getProductItems(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    fetchProductItems();
  }, []);

  const handleChangeStatus = async (user: any, index: number) => {
    const userId = user.id;
    const currentStatus = user.status;
    const newStatus = !currentStatus;
    const actionText = currentStatus ? "Deactivate" : "Activate";
    const result = await confirmationPopup(
      `Are you sure you want to ${actionText} this status?`
    );

    if (result.isConfirmed) {
      await updateProductItemStatus(userId, { status: newStatus });
      fetchProductItems();
    }
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = { ...filters, page: page + 1, limit: limit };
    setFilters(updatedFilters);
    fetchProductItems(updatedFilters);
  };

  console.log(data);

  return (
    <div className="pb-6">
      <h1 className="text-2xl sm:text-[32px] text-primaryText font-bold">
        Product Items
      </h1>

      <div className="flex justify-between items-center gap-5 my-6">
        {hasPermission(sitePermissions.productItemsCreate) && (
          <button
            onClick={() => navigate(siteRoutes.productItemsCreate)}
            className="px-4 py-2 text-sm bg-goldenOrangeBg text-white rounded-lg font-semibold"
          >
            Add New Item
          </button>
        )}
      </div>

      <div className="bg-white p-6 rounded-lg">
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((item: any, index: number) => (
            <div
              key={index + 1}
              className="bg-dividerLightBg relative  border border-stokeLight rounded-[30px] p-6 flex flex-col items-center justify-center gap-2 text-center h-fit"
            >
              {hasPermission(sitePermissions.productItemsUpdate) ? (
                <span
                  onClick={() => {
                    navigate(`${siteRoutes.productItemEdit}?id=${item.id}`);
                  }}
                  className="bg-goldenOrangeBg cursor-pointer p-2 rounded-md absolute top-5 right-5"
                >
                  <EditIcon className="w-4 h-4" />
                </span>
              ) : (
                <span className="bg-goldenOrangeBg cursor-not-allowed p-2 rounded-md absolute top-5 right-5">
                  <EditIcon className="w-4 h-4" />
                </span>
              )}

              <div className="relative mt-5">
                <img
                  src={
                    item?.image?.name
                      ? concatPathWithBackendUrl(item?.image?.name)
                      : editProfileUSer
                  }
                  alt={item?.name}
                  className="w-[157px] h-[177px] mt-4"
                />
              </div>

              <h3 className="text-primaryText text-2xl font-bold">
                {item?.itemName}
              </h3>

              <span className="text-base text-primaryText flex gap-2">
                {item?.cost ? `Cost ${item?.cost} pts` : ""}
              </span>
              <p className="text-primaryText">
                Delivery Fee:{" "}
                <span className="text-goldenAmberText">
                  {item?.deliveryFee > 0 ? `${item?.deliveryFee} pts` : "Free"}
                </span>
              </p>

              <span>
                {hasPermission(sitePermissions.productItemsUpdate) ? (
                  <label className="switch-field">
                    <input
                      type="checkbox"
                      checked={item?.status}
                      onChange={() => handleChangeStatus(item, index)}
                    />
                    <span className="slider"></span>
                  </label>
                ) : (
                  <label className="switch-field cursor-not-allowed opacity-60">
                    <input type="checkbox" checked={item?.status} disabled />
                    <span className="slider slider-disabled"></span>
                  </label>
                )}
              </span>
            </div>
          ))}
        </div>
        <Fragment>
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > (filters.limit || 9) && (
            <Pagination
              count={totalElements}
              page={filters.page}
              limit={filters.limit}
              onPageChange={onPageChange}
            />
          )}
        </Fragment>
      </div>
    </div>
  );
};

export default ProductItems;
